import script from "./TabComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TabComponent.vue?vue&type=script&setup=true&lang=js"

import "./TabComponent.vue?vue&type=style&index=0&id=b7041dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7041dc2"]])

export default __exports__